import { fromJS } from 'immutable';

export const API_HOST = process.env.REACT_APP_API_HOST;
export const IMAGE_HOST = process.env.REACT_APP_IMAGE_HOST;
export const VIDEO_HOST = process.env.REACT_APP_VIDEO_HOST;
export const THIRD_PARTY_LINK_URL = process.env.REACT_APP_THIRD_PARTY_LINK_URL;
export const THIRD_PARTY_LINK_DISPLAY_ENABLED =
  process.env.REACT_APP_THIRD_PARTY_LINK_DISPLAY_ENABLED === 'true';
export const IS_MISSION_DETAIL_IMAGE_NUMBER_THRESHOLD_ENABLED =
  process.env.REACT_APP_IS_MISSION_DETAIL_IMAGE_NUMBER_THRESHOLD_ENABLED === 'true';
export const MISSION_DETAIL_IMAGE_NUMBER_THRESHOLD =
  typeof process.env.REACT_APP_MISSION_DETAIL_IMAGE_NUMBER_THRESHOLD !== 'undefined'
    ? process.env.REACT_APP_MISSION_DETAIL_IMAGE_NUMBER_THRESHOLD
    : 10;

export const PAGESIZE_OPTIONS = process.env.REACT_APP_PAGESIZE_OPTIONS
  ? JSON.parse(process.env.REACT_APP_PAGESIZE_OPTIONS).map(n => n.toString())
  : ['10', '20', '30', '40', '50'];

export const ERROR_CODE_TIMEOUT = 'TIMEOUT';

export const API_STATUS_CODE_SUCCESS = '0x00000000';

export const POINT_MMRM_MODULE_NAMES = fromJS([
  { name: 'module_names.scheduler', code: 'scheduler' },
  { name: 'module_names.manual_operation', code: 'manual_operation' },
  { name: 'module_names.external', code: 'external' },
  { name: 'module_names.member_transaction', code: 'member_transaction' },
  { name: 'module_names.mission', code: 'mission' },
  { name: 'module_names.pickup_activity', code: 'pickup_activity' },
  { name: 'module_names.member_campaign', code: 'member_campaign' },
  { name: 'module_names.shop', code: 'shop' },
  { name: 'module_names.regular_customer', code: 'regular_customer' },
  { name: 'module_names.product_batch', code: 'product_batch' },
]);

export const LEVEL_MMRM_MODULE_NAMES = fromJS([
  { name: 'module_names.scheduler', code: 'scheduler' },
  { name: 'module_names.manual_operation', code: 'manual_operation' },
  { name: 'module_names.external', code: 'external' },
  { name: 'module_names.member_transaction', code: 'member_transaction' },
  { name: 'module_names.member_point', code: 'member_point' },
  { name: 'module_names.membership_level', code: 'membership_level' },
]);

export const MEMBER_CARD_MMRM_MODULE_NAMES = fromJS([
  { name: 'module_names.manual_operation', code: 'manual_operation' },
  { name: 'module_names.member', code: 'member' },
]);

export const TICKET_MMRM_MODULE_NAMES = fromJS([
  { name: 'module_names.manual_operation', code: 'manual_operation' },
  { name: 'module_names.external', code: 'external' },
  { name: 'module_names.mission', code: 'mission' },
  { name: 'module_names.pickup_activity', code: 'pickup_activity' },
  { name: 'module_names.member_campaign', code: 'member_campaign' },
  { name: 'module_names.shop', code: 'shop' },
  { name: 'module_names.regular_customer', code: 'regular_customer' },
  {
    name: 'module_names.voucher_sale_activity_order',
    code: 'voucher_sale_activity_order',
  },
]);

export const INTL_MONTH_MAP = fromJS([
  'date.month.january',
  'date.month.february',
  'date.month.march',
  'date.month.april',
  'date.month.may',
  'date.month.june',
  'date.month.july',
  'date.month.august',
  'date.month.september',
  'date.month.october',
  'date.month.november',
  'date.month.december',
]);

export const DEFAULT_IMAGE_SIZE_LIMIT_IN_BYTES = 512000; // 500 KB
export const DEFAULT_VIDEO_SIZE_LIMIT_IN_BYTES = 10485760; // 10 MB
export const DEFAULT_FILE_SIZE_LIMIT_IN_BYTES = 20971520; // 20 MB

export const YOUTUBE_URL = 'https://www.youtube.com';

export const TRANSACTION_ACTION = fromJS([
  { name: 'transaction_action.allocate', code: 'allocate' },
  { name: 'transaction_action.invalidate', code: 'invalidate' },
  { name: 'transaction_action.receive_ownership', code: 'receive_ownership' },
  { name: 'transaction_action.redeem', code: 'redeem' },
  { name: 'transaction_action.revoke', code: 'revoke' },
  { name: 'transaction_action.transfer_ownership', code: 'transfer_ownership' },
  { name: 'transaction_action.undo_redemption', code: 'undo_redemption' },
]);

const addOnImageSpecSuggestions = () => {
  const parse = JSON.parse(process.env.REACT_APP_RESTRICTION_MESSAGES_FOR_IMAGE_UPLOAD);

  // 預設值設定
  const defaultString = {
    shop_merchandise_spec: '建議圖片規格：640x400px png檔',
    mission_image: '建議圖片規格：640x400px png檔',
    mission_achievement_image: '建議圖片規格：640x400px png、gif檔',
    mission_achievement_detail_image: '建議圖片規格：640x400px png、gif檔',
    mission_detail_image: '建議圖片規格：640x400px png、gif檔',
  };

  Object.keys(defaultString).forEach(key => {
    if (!parse[key]) parse[key] = defaultString[key];
  });

  return parse;
};

export const IS_SHOW_MISSION_CANCELABLE_RADIO_BUTTON =
  process.env.REACT_APP_MISSION_CANCELABLE_RADIO_BUTTON === 'true';

export const RESTRICTION_MESSAGES_FOR_IMAGE_UPLOAD = process.env
  .REACT_APP_RESTRICTION_MESSAGES_FOR_IMAGE_UPLOAD
  ? addOnImageSpecSuggestions()
  : {};
